import { Box } from "@chakra-ui/react";
import { Instant } from "@js-joda/core";
import React from "react";
import { Messages } from "../../core/api";
import assert from "../../shared/utils/assert";
import { POCDocumentQuestion } from "./POCDocumentQuestion/POCDocumentQuestion";

export default function PatientDocumentPOCItem(props: {
  item: Messages["PatientDocumentContentItem"];
  currentAnswer: Messages["PatientDocumentAnswerObject"];
  readonly: boolean;
  onChangeAnswer: (
    id: number,
    chartRow: number,
    answer: Messages["POCItemsDocumentAnswer"][],
    answerObject: Messages["PatientDocumentAnswerObject"]
  ) => void;
}) {
  assert(
    props.currentAnswer.answer === null ||
      (Array.isArray(props.currentAnswer.answer) &&
        props.currentAnswer.answer.every((x) => typeof x === "object" && "attributes" in x)),
    "POC question got none poc answer!!!"
  );
  const [answers, setAnswers] = React.useState<Messages["POCItemsDocumentAnswer"][] | null>(
    props.currentAnswer.answer
  );

  const handleChangeAnswer = (id: number, answer: Messages["POCItemsDocumentAnswer"][]) => {
    setAnswers(answer);
    props.onChangeAnswer(id, -1, answer, {
      questionId: id,
      answer,
      answeredAt: Instant.now(),
      chartRow: -1,
    });
  };

  return (
    <Box mt={4}>
      <POCDocumentQuestion
        currentAnswer={answers}
        isRequired={props.item.isRequired ?? false}
        POCItems={props.item.POCItems ?? []}
        questionId={props.item.id}
        questionText={props.item.label}
        readonly={props.readonly}
        onClickWhileDisabled={() => {}}
        onInsertAnswer={handleChangeAnswer}
      />
    </Box>
  );
}
